// Dữ liệu mẫu «Hồ sơ vai trò» chép từ board Mint-Roles (RLD, 22 JD TblOrgJD). Chỉ đọc, không ghi DB.
export type Role = {
  code: string; dept: string; name: string; rpt: string; lv: string; cert: string; abbr: string; sum: string;
  duties: string[]; auth: [string, string][]; authNote: string; kpi: string[]; thinLv: string; thin: string;
  levels: [string, number, number, string][]; nDuty: number; ctx: string[]; dev: string[]; net: string; ctxK: string;
  loops: [string, string, string][]; see: string[]; hide: string[]; dec: [string, string][]; pains: string[];
  scr: [string, string][]; hub: Record<string, string>; impl: string[]; qs: string[];
};
export const DEPTS: [string, string, string][] = [["SALE", "Kinh doanh", "Sale"], ["CSD", "Dịch vụ khách hàng", "CS"], ["OPS", "Vận hành", "OPS"], ["TRD", "Vận tải", "Vận tải"], ["ACC", "Kế toán", "Kế toán"], ["HRD", "Hành chính – Nhân sự · IT", "HR/IT"], ["BOD", "Ban Giám đốc", "BOD"]];
export const ROLES: Role[] = [
 {
  "code": "SALE-MGR",
  "dept": "SALE",
  "name": "Trưởng phòng Kinh doanh",
  "rpt": "BOD-DIR",
  "lv": "L07",
  "cert": "",
  "abbr": "TP",
  "sum": "Chịu trách nhiệm kết quả kinh doanh (GP) của phòng; giữ tệp khách ổn định, phát triển đội ngũ.",
  "duties": [
   "Giao và theo dõi chỉ tiêu từng ghế kinh doanh",
   "Duyệt báo giá dưới sàn; đàm phán khách trọng điểm",
   "Đàm phán giá mua cước biển / hàng không với hãng, co-loader",
   "Lập kế hoạch giữ chỗ theo tuyến · tuần; chịu phí bỏ chỗ từ kế hoạch",
   "Khai thứ tự ưu tiên cấp chỗ khi khan cho tổ Đặt chỗ",
   "Thẩm định, đề xuất hạn mức công nợ khách"
  ],
  "auth": [
   [
    "QUOTE-MARGIN",
    "Duyệt giá dưới sàn (FRT, ISR)"
   ],
   [
    "BOOKING-STOCK-PROPOSE",
    "Đề xuất kế hoạch giữ chỗ"
   ],
   [
    "CREDIT-PROPOSE",
    "Đề xuất hạn mức công nợ"
   ],
   [
    "CUSTOMER-REASSIGN",
    "Chuyển khách giữa các ghế"
   ]
  ],
  "authNote": "Trong hạn mức của bậc · không tự duyệt hồ sơ mình lập · giữ chỗ vượt ngưỡng trình Giám đốc",
  "kpi": [
   "GP phòng",
   "Số khách hoạt động",
   "Tỷ lệ đơn bán kèm dịch vụ",
   "Phí bỏ chỗ từ kế hoạch",
   "Tỷ lệ công nợ quá hạn"
  ],
  "thinLv": "",
  "thin": "",
  "levels": [],
  "nDuty": 9,
  "ctx": [
   "vp",
   "ht"
  ],
  "dev": [
   "pc",
   "ph"
  ],
  "net": "ok",
  "ctxK": "Văn phòng · gặp khách",
  "loops": [
   [
    "Duyệt báo giá dưới sàn",
    "N",
    "5–10"
   ],
   [
    "Xem pipeline, chỉ tiêu từng ghế",
    "T",
    "1–2"
   ],
   [
    "Kế hoạch giữ chỗ theo tuyến",
    "T",
    "1"
   ],
   [
    "Thứ tự ưu tiên cấp chỗ khi khan",
    "T",
    "khi khan"
   ],
   [
    "Đề xuất hạn mức công nợ",
    "Th",
    "3–5"
   ]
  ],
  "see": [
   "Báo giá + cờ dưới sàn",
   "Pipeline, số job theo ghế",
   "Chỗ tồn theo tuyến",
   "Công nợ khách",
   "Giá mua + markup (quyền xem markup)"
  ],
  "hide": [
   "Sổ sách kế toán chi tiết",
   "Lương nhân viên"
  ],
  "dec": [
   [
    "Duyệt giá dưới sàn",
    "trong hạn mức bậc · JD chưa ghi số"
   ],
   [
    "Kế hoạch giữ chỗ",
    "vượt ngưỡng → BOD-DIR"
   ],
   [
    "Thứ tự ưu tiên chỗ khi khan",
    "khai sẵn cho BKG"
   ],
   [
    "Chuyển khách giữa ghế",
    "—"
   ]
  ],
  "pains": [
   "Duyệt báo giá trên điện thoại khi đang gặp khách, thiếu bối cảnh lô",
   "Không thấy một chỗ: chỗ tồn × dự báo lô × phí bỏ chỗ",
   "Thứ tự ưu tiên chỗ đang nằm trong đầu, chưa có nơi khai"
  ],
  "scr": [
   [
    "Báo giá",
    "Mint-Quote"
   ],
   [
    "Cơ hội",
    "Mint-Pipeline"
   ],
   [
    "Hôm nay của Sale",
    "Mint-SalesToday"
   ],
   [
    "Việc & Duyệt",
    "Mint-Tasks"
   ],
   [
    "Market Share",
    "Mint-MarketShare"
   ],
   [
    "KPI",
    "Mint-KPI"
   ]
  ],
  "hub": {
   "ezy": "main",
   "box": "yes",
   "hei": "yes",
   "mee": "yes",
   "edu": "yes",
   "mov": "no"
  },
  "impl": [
   "Duyệt giá dưới sàn 1 chạm trên điện thoại, kèm tóm tắt lô",
   "Màn \"Chỗ tồn & ưu tiên\" theo tuyến · tuần (chưa có)",
   "Chip \"cần duyệt giá\" ở danh sách, số chỉ trong màn báo giá"
  ],
  "qs": [
   "Một ngày anh duyệt bao nhiêu báo giá dưới sàn, phần lớn duyệt ở đâu (máy tính / điện thoại)?",
   "Khi chỗ khan, anh báo thứ tự ưu tiên cho BKG bằng cách nào?",
   "Anh cần thấy gì để quyết kế hoạch giữ chỗ tuần tới?"
  ]
 },
 {
  "code": "SALE-SE",
  "dept": "SALE",
  "name": "Nhân viên Kinh doanh",
  "rpt": "SALE-MGR",
  "lv": "L02–L05",
  "cert": "",
  "abbr": "SE",
  "sum": "Khai thác khách mới, giữ tệp khách được giao, đạt chỉ tiêu cá nhân.",
  "duties": [
   "Tìm khách mới, chăm sóc tệp khách được giao",
   "Lập báo giá theo biểu giá; dưới sàn thì chuyển cấp trên",
   "Chào trọn gói: cước + vận tải, hải quan, hun trùng, kiểm dịch",
   "Submit yêu cầu đặt chỗ đủ thông tin; chịu phí bỏ chỗ nếu dự báo sai",
   "Theo dõi công nợ tệp khách, phối hợp kế toán nhắc thu",
   "Cập nhật cơ hội và lịch sử tiếp xúc sau mỗi lần gặp khách"
  ],
  "auth": [
   [
    "QUOTE-MARGIN",
    "Chào giá trong biên của bậc (FRT)"
   ]
  ],
  "authNote": "Không duyệt hạn mức công nợ ở bất kỳ bậc nào · bảo hiểm chỉ ghi lựa chọn của khách",
  "kpi": [
   "GP cá nhân",
   "Khách mới phát sinh hàng",
   "Tỷ lệ báo giá thành công",
   "Số ngày thu tiền bình quân",
   "Phí bỏ chỗ do dự báo sai"
  ],
  "thinLv": "",
  "thin": "",
  "levels": [
   [
    "L02",
    3,
    2,
    "QUOTE-MARGIN"
   ],
   [
    "L03",
    3,
    2,
    "QUOTE-MARGIN"
   ],
   [
    "L04",
    3,
    2,
    "QUOTE-MARGIN"
   ],
   [
    "L05",
    3,
    1,
    "QUOTE-MARGIN"
   ]
  ],
  "nDuty": 8,
  "ctx": [
   "vp",
   "ht"
  ],
  "dev": [
   "pc",
   "ph"
  ],
  "net": "mid",
  "ctxK": "Văn phòng · thăm khách",
  "loops": [
   [
    "Lập báo giá",
    "N",
    "5–15"
   ],
   [
    "Submit yêu cầu đặt chỗ",
    "N",
    "2–6"
   ],
   [
    "Ghi tiếp xúc / cơ hội",
    "N",
    "3–8"
   ],
   [
    "Xem công nợ tệp khách",
    "T",
    "1–2"
   ],
   [
    "Tra giá & lịch tàu",
    "N",
    "10+"
   ]
  ],
  "see": [
   "Giá bán theo biểu giá",
   "Lịch tàu, chỗ",
   "Công nợ khách của mình",
   "Trạng thái job, cut-off",
   "Cờ \"cần duyệt giá\""
  ],
  "hide": [
   "Giá sàn (chỉ thấy cờ cần duyệt)",
   "Số tài chính lô ngoài màn tài chính",
   "Khách của ghế khác"
  ],
  "dec": [
   [
    "Chào giá trong biên",
    "QUOTE-MARGIN · hạn mức bậc"
   ],
   [
    "Dưới sàn",
    "→ SALE-MGR duyệt"
   ],
   [
    "Ghi PolicyHolder bảo hiểm",
    "theo lựa chọn khách"
   ]
  ],
  "pains": [
   "Báo giá trọn gói nhiều dịch vụ mất nhiều bước, dễ sót phí",
   "Không biết vì sao giá \"cần duyệt\" khi không thấy sàn",
   "Ghi tiếp xúc sau khi gặp khách bị dồn cuối ngày"
  ],
  "scr": [
   [
    "Hôm nay của Sale",
    "Mint-SalesToday"
   ],
   [
    "Báo giá",
    "Mint-Quote"
   ],
   [
    "Soạn báo giá",
    "Mint-QuoteEdit"
   ],
   [
    "Giá và Lịch",
    "Mint-P2P"
   ],
   [
    "Khách hàng",
    "Mint-Customers"
   ],
   [
    "Cơ hội",
    "Mint-Pipeline"
   ]
  ],
  "hub": {
   "ezy": "main",
   "box": "yes",
   "hei": "yes",
   "mee": "yes",
   "edu": "yes",
   "mov": "no"
  },
  "impl": [
   "Ẩn giá sàn; chỉ chip \"cần duyệt giá\" + lý do không số",
   "Ghi tiếp xúc nhanh bằng điện thoại / giọng nói sau buổi gặp",
   "Báo giá trọn gói: chọn gói dịch vụ, tự kéo dòng phí"
  ],
  "qs": [
   "Khi giá bị \"cần duyệt\", anh/chị cần biết gì để chào lại khách ngay?",
   "Anh/chị ghi lại buổi gặp khách lúc nào, bằng gì?",
   "Báo giá trọn gói gần nhất mất bao lâu, vướng ở bước nào?"
  ]
 },
 {
  "code": "SALE-PRC",
  "dept": "SALE",
  "name": "Nhân viên Pricing",
  "rpt": "SALE-MGR",
  "lv": "L03–L05",
  "cert": "",
  "abbr": "PRC",
  "sum": "Xây dựng và giữ biểu giá mua để kinh doanh luôn có giá cạnh tranh, đúng hạn.",
  "duties": [
   "Thu thập, cập nhật giá cước hãng tàu / hãng bay / co-loader theo tuyến",
   "Duy trì biểu giá và cấu hình biên theo tuyến",
   "Trả lời yêu cầu xin giá lô cụ thể trong thời gian cam kết",
   "Theo dõi hiệu lực hợp đồng giá, cảnh báo trước khi hết",
   "Phân tích lệch giá hợp đồng và giá mua thực tế"
  ],
  "auth": [],
  "authNote": "Không duyệt giá bán · giá ngoài hợp đồng trình Trưởng phòng KD",
  "kpi": [
   "Thời gian trả lời xin giá",
   "Tỷ lệ giá cập nhật đúng hạn",
   "Lệch giá hợp đồng và thực tế"
  ],
  "thinLv": "note",
  "thin": "KPI không có mốc thời gian cam kết trả lời xin giá",
  "levels": [
   [
    "L03",
    3,
    2,
    ""
   ],
   [
    "L04",
    3,
    1,
    ""
   ],
   [
    "L05",
    3,
    1,
    ""
   ]
  ],
  "nDuty": 6,
  "ctx": [
   "vp"
  ],
  "dev": [
   "pc"
  ],
  "net": "ok",
  "ctxK": "Văn phòng",
  "loops": [
   [
    "Nhập / cập nhật giá cước",
    "N",
    "20+ dòng"
   ],
   [
    "Trả lời phiếu hỏi giá",
    "N",
    "5–15"
   ],
   [
    "Rà hợp đồng giá sắp hết",
    "T",
    "1"
   ],
   [
    "Phân tích lệch giá",
    "Th",
    "1"
   ]
  ],
  "see": [
   "Giá mua theo hãng × tuyến",
   "Hiệu lực hợp đồng",
   "Phiếu hỏi giá + hạn",
   "Biến động giá"
  ],
  "hide": [
   "Công nợ khách",
   "Số tài chính lô ngoài màn tài chính"
  ],
  "dec": [
   [
    "Bấm Quoted / Skip phiếu hỏi giá",
    "hạn 24 giờ LV (tạm)"
   ],
   [
    "Giá ngoài hợp đồng",
    "→ SALE-MGR"
   ]
  ],
  "pains": [
   "Nhập giá từ file hãng nhiều định dạng, chép tay",
   "Phiếu hỏi giá dồn cùng lúc mùa cao điểm",
   "Khó thấy tuyến nào sắp hết hiệu lực"
  ],
  "scr": [
   [
    "Freight Cost",
    "Mint-Rates"
   ],
   [
    "Hỏi giá đối tác",
    "Mint-RateInquiry"
   ],
   [
    "Services Map",
    "Mint-ServicesMap"
   ],
   [
    "Thiết lập giá",
    "Mint-PriceSetup"
   ],
   [
    "Tin thị trường",
    "Mint-MarketNews"
   ]
  ],
  "hub": {
   "ezy": "main",
   "box": "yes",
   "hei": "yes",
   "mee": "yes",
   "edu": "yes",
   "mov": "no"
  },
  "impl": [
   "Bảng lưới dày, phím tắt, dán từ Excel",
   "AI đọc file giá hãng → điền sẵn có độ tin cậy",
   "Hàng chờ hỏi giá có đếm ngược hạn"
  ],
  "qs": [
   "Giá hãng gửi về dạng gì, mất bao lâu để lên hệ thống?",
   "Một ngày cao điểm có bao nhiêu phiếu hỏi giá?",
   "Anh/chị theo dõi hợp đồng sắp hết bằng cách nào?"
  ]
 },
 {
  "code": "SALE-OVS",
  "dept": "SALE",
  "name": "Nhân viên Oversea",
  "rpt": "SALE-MGR",
  "lv": "L03–L05",
  "cert": "",
  "abbr": "OVS",
  "sum": "Phát triển, giữ mạng lưới đại lý nước ngoài; khai thác hàng chỉ định về Việt Nam.",
  "duties": [
   "Tìm, đánh giá, ký kết đại lý ở thị trường trọng điểm",
   "Đàm phán mức chia và điều kiện cho hàng chỉ định",
   "Theo dõi lượng hàng hai chiều từng đại lý",
   "Nhận thông báo hàng đi từ đại lý, chuyển CS xử lý",
   "Phối hợp kế toán đối chiếu, bù trừ công nợ đại lý"
  ],
  "auth": [],
  "authNote": "Không có thẩm quyền độc lập · ký đại lý và mức chia cần Trưởng phòng KD duyệt",
  "kpi": [
   "Số lô hàng chỉ định",
   "Kết quả từ mạng lưới đại lý",
   "Cân đối hàng hai chiều",
   "Tuổi nợ đại lý"
  ],
  "thinLv": "note",
  "thin": "Không có thẩm quyền; luồng hàng chỉ định / net-off chưa mô tả bước trên hệ thống",
  "levels": [
   [
    "L03",
    2,
    2,
    ""
   ],
   [
    "L04",
    3,
    1,
    ""
   ],
   [
    "L05",
    3,
    1,
    ""
   ]
  ],
  "nDuty": 6,
  "ctx": [
   "vp"
  ],
  "dev": [
   "pc"
  ],
  "net": "ok",
  "ctxK": "Văn phòng · làm việc lệch múi giờ",
  "loops": [
   [
    "Trả lời đại lý qua mail",
    "N",
    "10+"
   ],
   [
    "Chuyển pre-alert cho CS",
    "N",
    "2–5"
   ],
   [
    "Theo dõi hàng hai chiều",
    "T",
    "1"
   ],
   [
    "Đối chiếu công nợ đại lý",
    "Th",
    "1"
   ]
  ],
  "see": [
   "Hồ sơ đối tác / đại lý",
   "Số lô hàng chỉ định hai chiều",
   "Công nợ đại lý (net-off)",
   "Pre-alert, lịch tàu"
  ],
  "hide": [
   "Giá sàn",
   "Số tài chính lô ngoài màn tài chính"
  ],
  "dec": [
   [
    "Đề xuất ký đại lý, mức chia",
    "→ SALE-MGR duyệt"
   ]
  ],
  "pains": [
   "Pre-alert đến ngoài giờ, chuyển CS chậm",
   "Không có màn cân đối hàng hai chiều theo đại lý",
   "Đối chiếu net-off phải hỏi kế toán"
  ],
  "scr": [
   [
    "Đối tác",
    "Mint-Partner"
   ],
   [
    "HANA Box",
    "Mint-Box"
   ],
   [
    "Hàng nhập & cont",
    "Mint-Import"
   ],
   [
    "Hợp đồng dịch vụ",
    "Mint-Contract"
   ]
  ],
  "hub": {
   "ezy": "main",
   "box": "yes",
   "hei": "yes",
   "mee": "yes",
   "edu": "yes",
   "mov": "no"
  },
  "impl": [
   "Thẻ đại lý: cân đối hàng hai chiều bằng biểu đồ, không số tiền",
   "Pre-alert từ Box → tạo lô nhập, giao CS 1 bước"
  ],
  "qs": [
   "Anh/chị nhận pre-alert lúc mấy giờ, chuyển CS thế nào?",
   "Cân đối hàng hai chiều đang theo dõi ở đâu?",
   "Khi đối chiếu công nợ đại lý, anh/chị cần thấy gì?"
  ]
 },
 {
  "code": "CSD-MGR",
  "dept": "CSD",
  "name": "Trưởng phòng Dịch vụ khách hàng",
  "rpt": "BOD-DIR",
  "lv": "L07",
  "cert": "",
  "abbr": "TP",
  "sum": "Lô hàng xử lý đúng hạn, chứng từ vận tải chính xác, dịch vụ đã bán được theo tới cùng.",
  "duties": [
   "Phân khách cho ghế: người chính + người dự phòng",
   "Vận hành bảng thời hạn: bảo hiểm trước ETD, trả rỗng, hạ bãi, SI, VGM, lược khai",
   "Duyệt B/L rủi ro cao: L/C, đổi B/L, đổi consignee sau phát hành",
   "Duyệt lệnh giao hàng khi khách còn dư nợ (cùng Kế toán công nợ)",
   "Bố trí ca soát chéo B/L, kể cả cao điểm",
   "Chủ trì khiếu nại, tổn thất, bồi thường bảo hiểm"
  ],
  "auth": [
   [
    "BL-ISSUE-HIGHRISK",
    "Phát hành B/L rủi ro cao"
   ],
   [
    "TELEX-RELEASE",
    "Điện giải phóng hàng"
   ],
   [
    "DO-RELEASE",
    "Lệnh giao hàng khi còn dư nợ"
   ],
   [
    "BL-AMEND-WAIVE",
    "Miễn phí sửa B/L"
   ],
   [
    "DEM-DET-ABSORB",
    "HANA chịu DEM/DET"
   ],
   [
    "COMPLAINT-COMP",
    "Bồi thường khiếu nại"
   ]
  ],
  "authNote": "Trong hạn mức của bậc · quy tắc có đồng duyệt: Kế toán công nợ xác nhận song song",
  "kpi": [
   "Tỷ lệ sai sót B/L",
   "Tỷ lệ trượt giờ chốt",
   "Thời gian phản hồi khách",
   "Chi phí bồi thường phát sinh",
   "Tỷ lệ đòi lại phí lưu cont"
  ],
  "thinLv": "",
  "thin": "",
  "levels": [],
  "nDuty": 9,
  "ctx": [
   "vp"
  ],
  "dev": [
   "pc",
   "ph"
  ],
  "net": "ok",
  "ctxK": "Văn phòng",
  "loops": [
   [
    "Rà bảng thời hạn phòng",
    "N",
    "2–3 lần"
   ],
   [
    "Duyệt B/L rủi ro cao / telex",
    "N",
    "2–5"
   ],
   [
    "Duyệt D/O khi còn dư nợ",
    "T",
    "2–4"
   ],
   [
    "Xếp ca soát chéo",
    "T",
    "1"
   ],
   [
    "Xử lý khiếu nại",
    "T",
    "1–3"
   ]
  ],
  "see": [
   "Bảng thời hạn toàn phòng",
   "B/L chờ duyệt",
   "Công nợ khách (cho D/O)",
   "Phí lưu cont hàng nhập",
   "Sai sót B/L theo người"
  ],
  "hide": [
   "Giá mua, markup",
   "Số tài chính lô ngoài màn tài chính"
  ],
  "dec": [
   [
    "B/L rủi ro cao, telex",
    "trong hạn mức bậc"
   ],
   [
    "D/O khi còn dư nợ",
    "song song với ACC-AR"
   ],
   [
    "HANA chịu DEM/DET, bồi thường",
    "trong hạn mức bậc · JD chưa ghi số"
   ]
  ],
  "pains": [
   "Bảng thời hạn đang rải ở nhiều nơi (bảo hiểm, trả rỗng, SI…)",
   "Duyệt D/O phải chờ kế toán xác nhận, không thấy trạng thái song song",
   "Khó xếp soát chéo khi có người nghỉ"
  ],
  "scr": [
   [
    "Việc & Duyệt",
    "Mint-Tasks"
   ],
   [
    "Chứng từ & B/L",
    "Mint-BL"
   ],
   [
    "Hàng nhập & cont",
    "Mint-Import"
   ],
   [
    "Danh sách Job",
    "Mint-Job"
   ],
   [
    "KPI",
    "Mint-KPI"
   ]
  ],
  "hub": {
   "ezy": "main",
   "box": "yes",
   "hei": "yes",
   "mee": "yes",
   "edu": "yes",
   "mov": "no"
  },
  "impl": [
   "Một màn \"Bảng thời hạn\" gộp mọi mốc của phòng (chưa có)",
   "Duyệt D/O hiện 2 ô song song: CS-MGR · ACC-AR",
   "Lịch soát chéo có ca dự phòng theo lịch nghỉ"
  ],
  "qs": [
   "Sáng đầu ngày chị nhìn gì trước để biết lô nào sắp trượt?",
   "D/O khi còn dư nợ: chị chờ kế toán bằng cách nào?",
   "Khi có người nghỉ, chị chia lại soát chéo ra sao?"
  ]
 },
 {
  "code": "CSD-TL",
  "dept": "CSD",
  "name": "Trưởng nhóm Dịch vụ khách hàng",
  "rpt": "CSD-MGR",
  "lv": "L06",
  "cert": "",
  "abbr": "TL",
  "sum": "Điều hành việc hằng ngày của tổ, giữ chất lượng B/L, không lô nào trượt giờ chốt.",
  "duties": [
   "Chia lô và tệp khách trong tổ, cân tải theo ngày",
   "Bố trí ca soát chéo B/L",
   "Theo dõi bảng thời hạn của tổ, can thiệp lô sắp trượt mốc",
   "Soát B/L lô phức tạp, xử lý vướng mắc với hãng",
   "Kèm cặp bậc thấp, đánh giá sẵn sàng nâng bậc"
  ],
  "auth": [
   [
    "BL-ISSUE",
    "Phát hành B/L"
   ],
   [
    "BL-AMEND-WAIVE",
    "Miễn phí sửa B/L"
   ]
  ],
  "authNote": "Trong hạn mức của bậc · B/L rủi ro cao vẫn trình Trưởng phòng",
  "kpi": [
   "Sai sót B/L của tổ",
   "Tỷ lệ trượt giờ chốt",
   "Tỷ lệ soát chéo đủ"
  ],
  "thinLv": "",
  "thin": "",
  "levels": [],
  "nDuty": 6,
  "ctx": [
   "vp"
  ],
  "dev": [
   "pc"
  ],
  "net": "ok",
  "ctxK": "Văn phòng",
  "loops": [
   [
    "Chia lô cho ghế",
    "N",
    "10–30"
   ],
   [
    "Rà bảng thời hạn tổ",
    "N",
    "3+ lần"
   ],
   [
    "Soát B/L lô phức tạp",
    "N",
    "2–5"
   ],
   [
    "Tổng hợp sai sót lặp",
    "Th",
    "1"
   ]
  ],
  "see": [
   "Tải việc theo ghế",
   "Bảng thời hạn tổ",
   "B/L chờ soát",
   "Sai sót theo loại"
  ],
  "hide": [
   "Giá mua, markup",
   "Số tài chính lô ngoài màn tài chính"
  ],
  "dec": [
   [
    "Phát hành B/L, miễn phí sửa",
    "trong hạn mức bậc"
   ],
   [
    "B/L rủi ro cao",
    "→ CSD-MGR"
   ]
  ],
  "pains": [
   "Không thấy tải việc từng ghế theo ngày để cân",
   "Can thiệp lô sắp trượt khi đã quá muộn"
  ],
  "scr": [
   [
    "Việc & Duyệt",
    "Mint-Tasks"
   ],
   [
    "Chứng từ & B/L",
    "Mint-BL"
   ],
   [
    "Danh sách Job",
    "Mint-Job"
   ],
   [
    "Trang chủ",
    "Mint-Home"
   ]
  ],
  "hub": {
   "ezy": "main",
   "box": "yes",
   "hei": "yes",
   "mee": "yes",
   "edu": "yes",
   "mov": "no"
  },
  "impl": [
   "Thanh tải việc theo ghế ở Việc của team",
   "Cảnh báo sớm theo mốc (đồng hồ), không chờ quá hạn"
  ],
  "qs": [
   "Chị chia lô buổi sáng dựa vào gì?",
   "Lô nào gần đây suýt trượt giờ chốt, chị phát hiện lúc nào?",
   "Chị cần gì để soát B/L nhanh hơn?"
  ]
 },
 {
  "code": "CSD-CSO",
  "dept": "CSD",
  "name": "Nhân viên Dịch vụ khách hàng",
  "rpt": "CSD-TL",
  "lv": "L02–L05",
  "cert": "",
  "abbr": "CS",
  "sum": "Đầu mối duy nhất của khách suốt vòng đời lô; chịu trách nhiệm vận đơn các lô mình phụ trách.",
  "duties": [
   "Nhận lô từ Đặt chỗ, kiểm dữ liệu gốc, trả lại nếu thiếu / sai",
   "Mở đủ dịch vụ đã bán ngay khi nhận lô",
   "Cấp đơn bảo hiểm trước khi tàu chạy",
   "Nhận SI, lập nháp B/L, khai VGM / lược khai, phát hành sau soát chéo",
   "Hàng nhập: thông báo hàng đến; chỉ phát D/O khi đã thu đủ",
   "Theo dõi hạn trả rỗng, nhắc khách trước khi phát sinh phí"
  ],
  "auth": [
   [
    "BL-ISSUE",
    "Phát hành B/L (từ L04, người duyệt khác người lập)"
   ],
   [
    "BL-AMEND-WAIVE",
    "Miễn phí sửa B/L (từ L04)"
   ]
  ],
  "authNote": "Không phát D/O / giải phóng hàng khi còn dư nợ · không duyệt B/L rủi ro cao · không cam kết phí",
  "kpi": [
   "Tỷ lệ sai sót B/L",
   "Tỷ lệ trượt giờ chốt",
   "Thời gian phản hồi khách",
   "Tỷ lệ phí thu đủ trên lô"
  ],
  "thinLv": "",
  "thin": "",
  "levels": [
   [
    "L02",
    3,
    3,
    ""
   ],
   [
    "L03",
    3,
    3,
    ""
   ],
   [
    "L04",
    5,
    3,
    "BL-ISSUE, BL-AMEND-WAIVE"
   ],
   [
    "L05",
    4,
    2,
    "BL-ISSUE, BL-AMEND-WAIVE"
   ]
  ],
  "nDuty": 17,
  "ctx": [
   "vp"
  ],
  "dev": [
   "pc",
   "ph"
  ],
  "net": "ok",
  "ctxK": "Văn phòng",
  "loops": [
   [
    "Nhận / trả lô từ BKG",
    "N",
    "5–15"
   ],
   [
    "Soạn, sửa nháp B/L",
    "N",
    "5–10"
   ],
   [
    "Trả lời khách",
    "N",
    "30+"
   ],
   [
    "Đề nghị phát hành debit",
    "N",
    "3–8"
   ],
   [
    "Thông báo hàng đến, trả rỗng",
    "N",
    "3–6"
   ]
  ],
  "see": [
   "Job, booking, B/L của mình",
   "Mốc SI / VGM / ETD",
   "Dịch vụ đã bán trên lô",
   "Giá bán trên Freight & Charges",
   "Công nợ khách (trạng thái thu đủ)"
  ],
  "hide": [
   "Giá mua, markup (chỉ thấy giá bán)",
   "Số tài chính lô ngoài màn tài chính"
  ],
  "dec": [
   [
    "Nhận hay trả lại lô từ BKG",
    "—"
   ],
   [
    "Phát hành B/L",
    "từ L04 · người duyệt khác người lập"
   ],
   [
    "Phát D/O",
    "chỉ khi ACC-AR xác nhận thu đủ"
   ]
  ],
  "pains": [
   "Mail khách, mail hãng, B/L nằm 3 nơi",
   "Quên mở dịch vụ đã bán → sót phí khi phát debit",
   "Đơn bảo hiểm cấp sát ETD, dễ trễ"
  ],
  "scr": [
   [
    "HANA Box",
    "Mint-Box"
   ],
   [
    "Chi tiết Job",
    "Mint-JobDetail"
   ],
   [
    "Soạn B/L",
    "Mint-BLEdit"
   ],
   [
    "Chứng từ & B/L",
    "Mint-BL"
   ],
   [
    "Hàng nhập & cont",
    "Mint-Import"
   ],
   [
    "Việc & Duyệt",
    "Mint-Tasks"
   ]
  ],
  "hub": {
   "ezy": "main",
   "box": "yes",
   "hei": "yes",
   "mee": "yes",
   "edu": "yes",
   "mov": "no"
  },
  "impl": [
   "Nhận lô có checklist dữ liệu gốc, \"Trả lại\" 1 chạm có lý do",
   "Cờ \"đã thu đủ\" trên lô nhập trước nút phát D/O",
   "Mốc bảo hiểm trước ETD trong Việc của tôi"
  ],
  "qs": [
   "Một ngày chị mở bao nhiêu cửa sổ để làm một lô?",
   "Lần gần nhất sót phí do chưa mở dịch vụ là khi nào?",
   "Chị biết khách đã thu đủ (để phát D/O) bằng cách nào?"
  ]
 },
 {
  "code": "CSD-BKG",
  "dept": "CSD",
  "name": "Nhân viên Đặt chỗ",
  "rpt": "CSD-MGR",
  "lv": "L01–L04",
  "cert": "",
  "abbr": "BKG",
  "sum": "Thực hiện yêu cầu đặt chỗ của Kinh doanh: đúng chuyến, đúng hạn, dữ liệu booking chính xác từ đầu.",
  "duties": [
   "Nhận yêu cầu đặt chỗ đã submit, kiểm đủ trước khi làm với hãng",
   "Đặt chỗ theo hợp đồng và hạn mức; lấy xác nhận + lệnh cấp rỗng",
   "Gán chỗ tồn có sẵn trước khi đặt mới",
   "Soát dữ liệu hệ thống bóc từ thư hãng, sửa lệch",
   "Theo dõi trễ / huỷ chuyến, bỏ cảng; tìm chỗ thay thế",
   "Cảnh báo trước hạn trả chỗ; bàn giao lô cho CS"
  ],
  "auth": [
   [
    "BOOKING-PLACE",
    "Đặt chỗ trong hạn mức (từ L02)"
   ]
  ],
  "authNote": "Thừa hành: không quyết mức chỗ tồn, không nhận vượt hạn mức khi chưa có SALE-MGR duyệt · bắt buộc cảnh báo",
  "kpi": [
   "Thời gian yêu cầu → xác nhận booking",
   "Tỷ lệ lấy chỗ đúng chuyến",
   "Tỷ lệ lô bị trả do sai dữ liệu gốc",
   "Tỷ lệ cảnh báo trả chỗ đúng hạn"
  ],
  "thinLv": "",
  "thin": "",
  "levels": [
   [
    "L01",
    2,
    2,
    ""
   ],
   [
    "L02",
    3,
    2,
    "BOOKING-PLACE"
   ],
   [
    "L03",
    3,
    1,
    "BOOKING-PLACE"
   ],
   [
    "L04",
    3,
    1,
    "BOOKING-PLACE"
   ]
  ],
  "nDuty": 9,
  "ctx": [
   "vp"
  ],
  "dev": [
   "pc"
  ],
  "net": "ok",
  "ctxK": "Văn phòng · áp lực giờ cắt",
  "loops": [
   [
    "Nhận yêu cầu đặt chỗ",
    "N",
    "20–40"
   ],
   [
    "Đặt chỗ, lấy xác nhận",
    "N",
    "15–30"
   ],
   [
    "Soát dữ liệu AI bóc từ thư hãng",
    "N",
    "15–30"
   ],
   [
    "Theo dõi trễ / huỷ chuyến",
    "N",
    "liên tục"
   ],
   [
    "Báo cáo chỗ tồn",
    "T",
    "1"
   ]
  ],
  "see": [
   "Yêu cầu đặt chỗ + hạn",
   "Hạn mức chỗ đã duyệt",
   "Chỗ tồn chưa gắn lô",
   "Lịch tàu, cut-off",
   "Thứ tự ưu tiên khi khan"
  ],
  "hide": [
   "Giá bán, markup",
   "Số tài chính lô ngoài màn tài chính"
  ],
  "dec": [
   [
    "Gán chỗ tồn cho yêu cầu",
    "theo ưu tiên SALE-MGR"
   ],
   [
    "Từ chối yêu cầu vượt hạn mức",
    "khi chưa có SALE-MGR duyệt"
   ],
   [
    "Bàn giao lô cho CS",
    "đủ booking + lệnh cấp rỗng"
   ]
  ],
  "pains": [
   "Thứ tự ưu tiên khi khan không có sẵn, phải hỏi",
   "Hạn trả chỗ theo dõi tay",
   "Sửa dữ liệu AI đọc sai mất thời gian"
  ],
  "scr": [
   [
    "Booking",
    "Mint-Booking"
   ],
   [
    "AI đọc chứng từ",
    "Mint-AIRead"
   ],
   [
    "Giá và Lịch",
    "Mint-P2P"
   ],
   [
    "HANA Box",
    "Mint-Box"
   ],
   [
    "Việc & Duyệt",
    "Mint-Tasks"
   ]
  ],
  "hub": {
   "ezy": "main",
   "box": "yes",
   "hei": "yes",
   "mee": "yes",
   "edu": "yes",
   "mov": "no"
  },
  "impl": [
   "Dòng chỗ tồn chưa gắn lô có đồng hồ hạn trả chỗ",
   "Ưu tiên khi khan hiện ngay trên yêu cầu (đọc từ SALE-MGR)",
   "Ô AI đọc tô theo độ tin cậy, Tab nhảy ô kém"
  ],
  "qs": [
   "Ngày cao điểm em nhận bao nhiêu yêu cầu, giờ nào dồn nhất?",
   "Khi khan chỗ, em biết lô nào được ưu tiên bằng cách nào?",
   "Em theo dõi hạn trả chỗ ở đâu?"
  ]
 },
 {
  "code": "OPS-MGR",
  "dept": "OPS",
  "name": "Trưởng phòng Vận hành",
  "rpt": "BOD-DIR",
  "lv": "L07",
  "cert": "Chứng chỉ nghiệp vụ khai hải quan",
  "abbr": "TP",
  "sum": "Khai hải quan chính xác, đúng hạn; kiểm soát chất lượng và giá mua dịch vụ thuê ngoài; điều tiết tổ hiện trường.",
  "duties": [
   "Phân công, kiểm soát khối lượng hồ sơ trong phòng",
   "Rà hồ sơ rủi ro cao: quản lý chuyên ngành, mã nhạy cảm, trị giá bất thường",
   "Quyết hướng xử lý luồng vàng / đỏ; chấp nhận hay bảo lưu khi hải quan đề nghị áp mã khác",
   "Chọn, đánh giá nhà thầu hun trùng, kiểm dịch, bãi; ký hợp đồng khung",
   "Điều tiết tổ hiện trường giữa cảng, chi cục, cơ quan cấp chứng thư",
   "Đối chiếu hoá đơn nhà thầu với khoản trên lô trước khi chuyển kế toán"
  ],
  "auth": [
   [
    "HS-CODE-APPROVE",
    "Duyệt mã HS"
   ],
   [
    "HS-CODE-CONCEDE",
    "Chấp nhận áp mã khác (độc quyền)"
   ],
   [
    "DECLARATION-AMEND",
    "Sửa tờ khai"
   ],
   [
    "DOC-FEE-WAIVE",
    "Miễn phí chứng từ"
   ],
   [
    "VENDOR-RATE-APPROVE",
    "Duyệt đơn giá nhà thầu (FUM, PTF, COO, SCY)"
   ]
  ],
  "authNote": "Trong hạn mức của bậc",
  "kpi": [
   "Tỷ lệ tờ khai phải sửa",
   "Tỷ lệ hồ sơ đúng hạn",
   "Số vụ bị xử phạt",
   "Biên dịch vụ thuê ngoài"
  ],
  "thinLv": "",
  "thin": "",
  "levels": [],
  "nDuty": 10,
  "ctx": [
   "vp",
   "ht"
  ],
  "dev": [
   "pc",
   "ph"
  ],
  "net": "ok",
  "ctxK": "Văn phòng · ra chi cục khi cần",
  "loops": [
   [
    "Duyệt mã HS rủi ro",
    "N",
    "3–8"
   ],
   [
    "Xử lý luồng vàng / đỏ",
    "N",
    "1–4"
   ],
   [
    "Điều tổ hiện trường",
    "N",
    "liên tục"
   ],
   [
    "Duyệt đơn giá nhà thầu",
    "Th",
    "2–5"
   ],
   [
    "Đối chiếu hoá đơn nhà thầu",
    "T",
    "1–2"
   ]
  ],
  "see": [
   "Hồ sơ rủi ro, phân luồng",
   "Căn cứ áp mã",
   "Vị trí / việc của tổ hiện trường",
   "Giá mua dịch vụ thuê ngoài",
   "Định mức chi phí dịch vụ"
  ],
  "hide": [
   "Giá bán, markup (Freight & Charges chỉ giá bán)",
   "Số tài chính lô ngoài màn tài chính"
  ],
  "dec": [
   [
    "Chấp nhận / bảo lưu áp mã khác",
    "HS-CODE-CONCEDE · độc quyền"
   ],
   [
    "Sửa tờ khai, miễn phí chứng từ",
    "trong hạn mức bậc"
   ],
   [
    "Đơn giá nhà thầu",
    "VENDOR-RATE-APPROVE · JD chưa ghi số"
   ],
   [
    "Duyệt chi phí dịch vụ",
    "chuỗi Lập → trưởng bộ phận → ACC-CP → ACC-CA"
   ]
  ],
  "pains": [
   "Hiện trường gọi điện hỏi quyết định lúc đang kiểm hoá",
   "Không thấy tổ hiện trường đang ở đâu, việc gì",
   "Kiểm giá bán ≥ giá mua + phí tối thiểu mà không được thấy giá bán"
  ],
  "scr": [
   [
    "Service Hub",
    "Mint-Service"
   ],
   [
    "Tra HS",
    "Mint-HS"
   ],
   [
    "Định mức",
    "Mint-Norms"
   ],
   [
    "Việc & Duyệt",
    "Mint-Tasks"
   ],
   [
    "Customs Data",
    "Mint-CustomsData"
   ]
  ],
  "hub": {
   "ezy": "main",
   "box": "yes",
   "hei": "yes",
   "mee": "yes",
   "edu": "yes",
   "mov": "no"
  },
  "impl": [
   "Duyệt HS-CODE-CONCEDE trên điện thoại kèm căn cứ áp mã",
   "Bản đồ / danh sách tổ hiện trường theo việc",
   "Kiểm \"dưới sàn\" bằng cờ, không mở giá bán (JD mâu thuẫn luật tiền)"
  ],
  "qs": [
   "Khi hiện trường báo hải quan đề nghị áp mã khác, anh quyết trong bao lâu, dựa vào gì?",
   "Anh biết tổ hiện trường đang ở đâu bằng cách nào?",
   "Anh có cần thấy giá bán để kiểm giá thuê ngoài không, hay chỉ cần cờ?"
  ]
 },
 {
  "code": "OPS-DOC",
  "dept": "OPS",
  "name": "Nhân viên chứng từ",
  "rpt": "OPS-MGR",
  "lv": "L02–L05",
  "cert": "Chứng chỉ nghiệp vụ khai hải quan (bắt buộc từ L03)",
  "abbr": "DOC",
  "sum": "Lo trọn giấy tờ pháp lý của lô: tờ khai hải quan và chứng thư bắt buộc, chính xác, đúng hạn.",
  "duties": [
   "Kiểm bộ hồ sơ khách trước khi khai; đối chiếu tờ khai với B/L",
   "Xác định mã HS, trị giá, chính sách mặt hàng",
   "Ghi hồ sơ căn cứ áp mã trước khi truyền, cho hiện trường dùng khi đối chất",
   "Truyền tờ khai, theo dõi phân luồng; báo thuế / lệ phí khách nộp",
   "Lập hồ sơ C/O; đặt lịch hun trùng, kiểm dịch khớp giờ cắt máng",
   "Ghi giá mua thực tế của nhà thầu vào lô ngay khi có hoá đơn"
  ],
  "auth": [
   [
    "HS-CODE-PROPOSE",
    "Đề xuất mã HS (từ L03)"
   ],
   [
    "VENDOR-BOOK",
    "Đặt dịch vụ thuê ngoài theo hợp đồng khung (FUM, PTF)"
   ]
  ],
  "authNote": "Vượt đơn giá khung hoặc có rủi ro áp mã → trình Trưởng phòng trước khi truyền · truyền tờ khai cần chứng chỉ (từ L03)",
  "kpi": [
   "Tỷ lệ tờ khai phải sửa",
   "Thời gian thông quan bình quân",
   "Tỷ lệ chứng thư đúng hạn",
   "Tỷ lệ chứng thư cấp lại",
   "Tỷ lệ ghi giá mua đúng hạn"
  ],
  "thinLv": "note",
  "thin": "Dữ liệu bậc nằm dưới mã OPS-CD, không khớp mã JD",
  "levels": [
   [
    "L02",
    3,
    2,
    "VENDOR-BOOK"
   ],
   [
    "L03",
    3,
    2,
    "HS-CODE-PROPOSE, VENDOR-BOOK"
   ],
   [
    "L04",
    3,
    1,
    "HS-CODE-PROPOSE, VENDOR-BOOK"
   ],
   [
    "L05",
    3,
    1,
    "HS-CODE-PROPOSE, VENDOR-BOOK"
   ]
  ],
  "nDuty": 14,
  "ctx": [
   "vp"
  ],
  "dev": [
   "pc"
  ],
  "net": "ok",
  "ctxK": "Văn phòng",
  "loops": [
   [
    "Kiểm hồ sơ, khai tờ khai",
    "N",
    "5–15"
   ],
   [
    "Ghi căn cứ áp mã",
    "N",
    "5–15"
   ],
   [
    "Lập hồ sơ C/O",
    "N",
    "2–6"
   ],
   [
    "Đặt lịch hun trùng / kiểm dịch",
    "N",
    "2–5"
   ],
   [
    "Ghi giá mua nhà thầu",
    "N",
    "5–10"
   ]
  ],
  "see": [
   "Bộ hồ sơ khách, B/L",
   "Tra HS, tiền lệ mặt hàng",
   "Kết quả phân luồng",
   "Lịch đóng hàng, cut-off",
   "Chi phí và giá gốc dịch vụ"
  ],
  "hide": [
   "Giá bán, markup",
   "Số tài chính lô ngoài màn tài chính"
  ],
  "dec": [
   [
    "Đề xuất mã HS",
    "từ L03 · rủi ro → OPS-MGR trước khi truyền"
   ],
   [
    "Đặt dịch vụ thuê ngoài",
    "theo đơn giá khung · vượt → OPS-MGR"
   ]
  ],
  "pains": [
   "Căn cứ áp mã ghi rời, hiện trường không có khi bị đối chất",
   "Đối chiếu tờ khai – B/L – chứng thư làm tay",
   "Lịch hun trùng lệch giờ cắt máng"
  ],
  "scr": [
   [
    "Service Hub",
    "Mint-Service"
   ],
   [
    "Tra HS",
    "Mint-HS"
   ],
   [
    "Customs Data",
    "Mint-CustomsData"
   ],
   [
    "AI đọc chứng từ",
    "Mint-AIRead"
   ],
   [
    "Chi tiết Job",
    "Mint-JobDetail"
   ]
  ],
  "hub": {
   "ezy": "main",
   "box": "yes",
   "hei": "yes",
   "mee": "yes",
   "edu": "yes",
   "mov": "no"
  },
  "impl": [
   "Thẻ \"Căn cứ áp mã\" trên dịch vụ CCF, đồng bộ sang điện thoại hiện trường (chưa có)",
   "So 3 chứng từ cạnh nhau, tô ô lệch",
   "Ẩn Markup / Giá debit; thấy và sửa Chi phí, Giá gốc"
  ],
  "qs": [
   "Căn cứ áp mã đang lưu ở đâu, hiện trường lấy thế nào?",
   "Đối chiếu tờ khai với B/L mất bao lâu mỗi lô?",
   "Lần gần nhất lịch hun trùng lệch cut-off là vì sao?"
  ]
 },
 {
  "code": "OPS-FLD",
  "dept": "OPS",
  "name": "Nhân viên hiện trường",
  "rpt": "OPS-MGR",
  "lv": "L02–L05",
  "cert": "Chứng chỉ nghiệp vụ khai hải quan (bắt buộc từ L05 để kiểm hoá luồng đỏ)",
  "abbr": "FLD",
  "sum": "Làm toàn bộ việc tại cảng, chi cục, cơ quan cấp chứng thư: nhận hàng, giám sát đóng cont, xuất trình hồ sơ, nhận chứng thư.",
  "duties": [
   "Nhận hàng tại bãi: đếm kiện, kiểm bao bì, biên bản kèm ảnh",
   "Giám sát đóng cont; ghi số cont, seal, VGM về hệ thống ngay",
   "Báo CS khi hàng thực nhận lệch booking, trước khi đóng cont",
   "Xuất trình hồ sơ tại chi cục, phối hợp kiểm hoá, bảo vệ mã đã khai",
   "Nhận chứng thư, quét ảnh trước khi rời cơ quan cấp",
   "Ghi chi phí hiện trường: lệ phí, nâng hạ, bốc xếp, chờ xe"
  ],
  "auth": [
   [
    "CARGO-RECEIPT",
    "Ký nhận hàng thay HANA (từ L04)"
   ],
   [
    "FIELD-ADVANCE",
    "Tạm ứng hiện trường trong hạn mức bậc"
   ]
  ],
  "authNote": "Không nhượng bộ tại chỗ khi hải quan đề nghị áp mã khác · không nhận hàng lệch vượt ngưỡng khi chưa có CS / Trưởng phòng · không ứng mới khi đợt cũ chưa quyết toán",
  "kpi": [
   "Biên bản đủ chữ ký + ảnh",
   "Độ chính xác seal / khối lượng",
   "Thời gian yêu cầu → hoàn thành",
   "Hoàn ứng đúng hạn",
   "Chứng từ gốc thất lạc"
  ],
  "thinLv": "",
  "thin": "",
  "levels": [
   [
    "L02",
    3,
    3,
    "FIELD-ADVANCE"
   ],
   [
    "L03",
    3,
    2,
    "FIELD-ADVANCE"
   ],
   [
    "L04",
    5,
    2,
    "CARGO-RECEIPT, FIELD-ADVANCE"
   ],
   [
    "L05",
    4,
    1,
    "CARGO-RECEIPT, FIELD-ADVANCE"
   ]
  ],
  "nDuty": 13,
  "ctx": [
   "ht"
  ],
  "dev": [
   "ph"
  ],
  "net": "low",
  "ctxK": "Hiện trường: cảng, bãi, chi cục",
  "loops": [
   [
    "Biên bản nhận hàng + ảnh",
    "N",
    "3–8"
   ],
   [
    "Ghi số cont, seal, VGM",
    "N",
    "3–8"
   ],
   [
    "Quét chứng thư / hồ sơ gốc",
    "N",
    "3–6"
   ],
   [
    "Nhập phiếu chi hiện trường",
    "N",
    "5–15"
   ],
   [
    "Quyết toán tạm ứng",
    "T",
    "1–2"
   ]
  ],
  "see": [
   "Việc hôm nay theo địa điểm",
   "Booking: số kiện, khối lượng để so",
   "Căn cứ áp mã của lô",
   "Tạm ứng đang giữ",
   "Định mức chi theo cảng"
  ],
  "hide": [
   "Giá bán, markup",
   "Số tài chính lô ngoài màn tài chính"
  ],
  "dec": [
   [
    "Ký nhận hàng",
    "từ L04 · lệch vượt ngưỡng → CS / OPS-MGR"
   ],
   [
    "Chi tại hiện trường",
    "trong định mức · vượt → trưởng bộ phận"
   ],
   [
    "Bảo lưu khi hải quan đề nghị áp mã khác",
    "không nhượng bộ tại chỗ"
   ]
  ],
  "pains": [
   "Mất sóng ở bãi, ảnh biên bản gửi không đi",
   "Một tay cầm hồ sơ, một tay chụp; găng tay, nắng chói",
   "Phiếu chi tiền mặt nhỏ, dồn cuối ngày mới nhập"
  ],
  "scr": [
   [
    "Service Hub · điện thoại",
    "Mint-Service-Phone"
   ],
   [
    "Hàng nhập · điện thoại",
    "Mint-Import-Phone"
   ],
   [
    "Chi tiết Job · điện thoại",
    "Mint-JobDetail-Phone"
   ],
   [
    "Chi phí · điện thoại",
    "Mint-Cost-Phone"
   ],
   [
    "HANA Mee",
    "Mint-Mee-Phone"
   ]
  ],
  "hub": {
   "ezy": "main",
   "box": "no",
   "hei": "yes",
   "mee": "yes",
   "edu": "yes",
   "mov": "no"
  },
  "impl": [
   "Nút to (≥ 48px), một tay, tương phản cao ngoài nắng",
   "Chạy offline: lưu biên bản, ảnh, seal; gửi bù khi có sóng (chưa có ngoài Mov)",
   "Quét chứng thư bắt buộc trước khi rời cơ quan (nhắc theo vị trí)",
   "Nhập phiếu chi 3 chạm: ảnh → AI điền → mã bản chất tự điền"
  ],
  "qs": [
   "Ở bãi nào hay mất sóng nhất, anh xử lý ảnh biên bản thế nào?",
   "Anh ghi số seal, VGM lúc nào và gửi về bằng gì?",
   "Khi hải quan đề nghị áp mã khác, anh cần thấy gì trên điện thoại?"
  ]
 },
 {
  "code": "TRD-MGR",
  "dept": "TRD",
  "name": "Trưởng phòng Vận tải",
  "rpt": "BOD-DIR",
  "lv": "L07",
  "cert": "",
  "abbr": "TP",
  "sum": "Vận chuyển đúng lịch, an toàn, chi phí tối ưu; quản lý đội xe và nhà thầu vận tải.",
  "duties": [
   "Lập kế hoạch điều động ngày, cân xe nhà và nhà thầu ngoài",
   "Xây và cập nhật bảng giá cước vận tải theo tuyến cho KD chào giá",
   "Đàm phán, quản lý hợp đồng nhà thầu vận tải",
   "Kiểm soát nhiên liệu, phí đường bộ, phát sinh từng chuyến",
   "Giám sát bảo dưỡng, đăng kiểm, bảo hiểm đội xe",
   "Xử lý sự cố dọc đường; giám sát giờ lái, tốc độ qua định vị"
  ],
  "auth": [
   [
    "TRUCKING-RATE-APPROVE",
    "Duyệt giá cước vận tải"
   ],
   [
    "TRIP-COST-APPROVE",
    "Duyệt phát sinh chuyến"
   ],
   [
    "VEHICLE-MAINT",
    "Bảo dưỡng, sửa chữa xe"
   ],
   [
    "VENDOR-RATE-APPROVE",
    "Duyệt đơn giá nhà thầu (TRF)"
   ]
  ],
  "authNote": "Trong hạn mức của bậc",
  "kpi": [
   "Tỷ lệ giao nhận đúng hẹn",
   "Chi phí vận tải / chuyến",
   "Tỷ lệ xe hoạt động",
   "Số vụ tai nạn, sự cố"
  ],
  "thinLv": "",
  "thin": "",
  "levels": [],
  "nDuty": 7,
  "ctx": [
   "vp",
   "ht"
  ],
  "dev": [
   "pc",
   "ph"
  ],
  "net": "ok",
  "ctxK": "Văn phòng · bãi xe",
  "loops": [
   [
    "Xem kế hoạch điều động ngày",
    "N",
    "1–2"
   ],
   [
    "Duyệt phát sinh chuyến",
    "N",
    "3–10"
   ],
   [
    "Xử lý sự cố dọc đường",
    "T",
    "1–3"
   ],
   [
    "Cập nhật bảng giá TRF",
    "Th",
    "1"
   ],
   [
    "Duyệt sửa chữa vượt hạn mức",
    "Th",
    "2–4"
   ]
  ],
  "see": [
   "Lưới điều xe, xe nhà / thuê ngoài",
   "Vị trí xe, giờ lái",
   "Phát sinh chuyến vs định mức",
   "Đội xe, hạn đăng kiểm",
   "Giá cước TRF theo tuyến"
  ],
  "hide": [
   "Số tài chính lô ngoài màn tài chính"
  ],
  "dec": [
   [
    "Giá cước vận tải",
    "TRUCKING-RATE-APPROVE"
   ],
   [
    "Phát sinh chuyến vượt định mức",
    "TRIP-COST-APPROVE · JD chưa ghi số"
   ],
   [
    "Đơn giá nhà thầu TRF",
    "VENDOR-RATE-APPROVE"
   ]
  ],
  "pains": [
   "Duyệt phát sinh khi đang ở bãi, thiếu ảnh / GPS đi kèm",
   "Không thấy nhanh xe nào sắp quá giờ lái"
  ],
  "scr": [
   [
    "Điều độ",
    "Mint-TMS"
   ],
   [
    "Lưới điều xe",
    "Mint-TMS-Dispatch"
   ],
   [
    "Tính giá TRF",
    "Mint-TMS-RoutePrice"
   ],
   [
    "Tuyến",
    "Mint-TMS-Routes"
   ],
   [
    "Đội xe & danh mục",
    "Mint-TMS-Fleet"
   ],
   [
    "HANA Mov",
    "Mint-Mov-Phone"
   ]
  ],
  "hub": {
   "ezy": "main",
   "box": "yes",
   "hei": "yes",
   "mee": "yes",
   "edu": "yes",
   "mov": "perm"
  },
  "impl": [
   "Duyệt phát sinh kèm ảnh + mốc GPS của chuyến",
   "Cờ giờ lái liên tục trên lưới điều xe"
  ],
  "qs": [
   "Anh duyệt phát sinh chuyến ở đâu, cần chứng cứ gì?",
   "Anh biết xe nào sắp quá giờ lái bằng cách nào?",
   "Bảng giá TRF đổi theo nhịp nào?"
  ]
 },
 {
  "code": "TRD-DSP",
  "dept": "TRD",
  "name": "Nhân viên Điều độ",
  "rpt": "TRD-MGR",
  "lv": "L02–L04",
  "cert": "",
  "abbr": "DSP",
  "sum": "Điều phối xe và tài xế hằng ngày để mọi chuyến đúng hẹn với khách và cảng.",
  "duties": [
   "Nhận yêu cầu vận chuyển, xếp xe, phân tài xế theo tuyến",
   "Cấp lệnh điều xe, theo dõi hành trình qua định vị",
   "Bố trí xe kéo rỗng cho đóng hàng, khớp giờ hạ bãi / cắt máng",
   "Báo tiến độ cho CS, cảnh báo sớm nguy cơ trễ",
   "Ghi chi phí từng chuyến; bám hạn mượn / trả rỗng",
   "Đối chiếu chứng từ giao nhận với tài xế sau chuyến"
  ],
  "auth": [
   [
    "TRIP-COST-RECORD",
    "Ghi chi phí chuyến"
   ]
  ],
  "authNote": "Khoản vượt định mức tuyến trình Trưởng phòng",
  "kpi": [
   "Tỷ lệ chuyến đúng hẹn",
   "Tỷ lệ xe chạy rỗng",
   "Phí lưu bãi / lưu cont phát sinh"
  ],
  "thinLv": "",
  "thin": "",
  "levels": [
   [
    "L02",
    3,
    2,
    "TRIP-COST-RECORD"
   ],
   [
    "L03",
    4,
    2,
    "TRIP-COST-RECORD"
   ],
   [
    "L04",
    3,
    1,
    "TRIP-COST-RECORD"
   ]
  ],
  "nDuty": 8,
  "ctx": [
   "vp"
  ],
  "dev": [
   "pc",
   "ph"
  ],
  "net": "ok",
  "ctxK": "Văn phòng · điện thoại liên tục",
  "loops": [
   [
    "Xếp xe, cấp lệnh điều xe",
    "N",
    "20–50"
   ],
   [
    "Theo dõi hành trình",
    "N",
    "liên tục"
   ],
   [
    "Báo tiến độ cho CS",
    "N",
    "10+"
   ],
   [
    "Ghi chi phí chuyến",
    "N",
    "20–50"
   ],
   [
    "Bám hạn mượn / trả rỗng",
    "N",
    "5–15"
   ]
  ],
  "see": [
   "Lưới điều xe theo giờ",
   "Vị trí xe (GPS)",
   "Cut-off, giờ hạ bãi",
   "Định mức tuyến",
   "Hạn trả rỗng"
  ],
  "hide": [
   "Giá bán, markup",
   "Số tài chính lô ngoài màn tài chính"
  ],
  "dec": [
   [
    "Phân xe, tài xế",
    "—"
   ],
   [
    "Chấp thuận chi ngoài định mức của tài xế",
    "vượt định mức tuyến → TRD-MGR"
   ],
   [
    "Gọi nhà thầu ngoài khi thiếu xe",
    "từ L04"
   ]
  ],
  "pains": [
   "Vừa nghe điện thoại vừa kéo thả trên lưới",
   "Tài xế gọi xin chi phát sinh, khó ghi kịp",
   "Hạn trả rỗng dễ sót khi nhiều cont"
  ],
  "scr": [
   [
    "Điều độ",
    "Mint-TMS"
   ],
   [
    "Lưới điều xe",
    "Mint-TMS-Dispatch"
   ],
   [
    "Lệnh vận chuyển",
    "Mint-TMS-Trip"
   ],
   [
    "Bản đồ điểm & tuyến",
    "Mint-TMS-Places"
   ],
   [
    "HANA Mov",
    "Mint-Mov-Phone"
   ]
  ],
  "hub": {
   "ezy": "main",
   "box": "yes",
   "hei": "yes",
   "mee": "yes",
   "edu": "yes",
   "mov": "perm"
  },
  "impl": [
   "Lưới điều xe thao tác bằng phím, không cần chuột chính xác",
   "Yêu cầu chi phát sinh từ Mov vào hàng chờ 1 chạm duyệt",
   "Đồng hồ hạn trả rỗng trên từng cont"
  ],
  "qs": [
   "Một ngày anh cấp bao nhiêu lệnh, lúc nào dồn nhất?",
   "Tài xế xin chi phát sinh bằng cách nào?",
   "Hạn trả rỗng anh nhớ bằng gì?"
  ]
 },
 {
  "code": "TRD-DRV",
  "dept": "TRD",
  "name": "Tài xế",
  "rpt": "TRD-MGR",
  "lv": "L01–L03",
  "cert": "Giấy phép lái xe hạng phù hợp, còn hiệu lực",
  "abbr": "DRV",
  "sum": "Chạy hàng an toàn, đúng lịch, đúng luật giao thông.",
  "duties": [
   "Chạy theo lệnh điều xe, không tự đổi lộ trình",
   "Kiểm xe và cont trước chuyến, báo hỏng ngay",
   "Nhận, giao chứng từ có xác nhận bên nhận",
   "Giữ liên lạc với điều độ, báo sự cố ngay",
   "Nộp đủ hoá đơn, chứng từ phát sinh sau chuyến"
  ],
  "auth": [],
  "authNote": "Không có thẩm quyền duyệt · chi ngoài định mức phải được điều độ chấp thuận trước",
  "kpi": [
   "Tỷ lệ chuyến đúng hẹn",
   "Số vi phạm giao thông",
   "Tiêu hao nhiên liệu",
   "Tình trạng bảo quản xe"
  ],
  "thinLv": "thin",
  "thin": "JD chưa nhắc app, POD, mốc chuyến, tạm ứng — phần trên hệ thống gần như suy luận hết",
  "levels": [
   [
    "L01",
    2,
    2,
    ""
   ],
   [
    "L02",
    3,
    2,
    ""
   ],
   [
    "L03",
    3,
    1,
    ""
   ]
  ],
  "nDuty": 6,
  "ctx": [
   "xe"
  ],
  "dev": [
   "ph"
  ],
  "net": "low",
  "ctxK": "Trên xe · cảng · bãi",
  "loops": [
   [
    "Nhận lệnh, bắt đầu chuyến",
    "N",
    "1–4"
   ],
   [
    "Ghi mốc + ảnh POD",
    "N",
    "4–12"
   ],
   [
    "Checklist xe trước chuyến",
    "N",
    "1–4"
   ],
   [
    "Nộp chứng từ chi phí",
    "N",
    "1–4"
   ],
   [
    "Chấm công, xin nghỉ",
    "Th",
    "1–2"
   ]
  ],
  "see": [
   "Chỉ HANA Mov: chuyến của mình, điểm, mốc",
   "Tạm ứng của tôi",
   "Lương chuyến tạm tính của mình"
  ],
  "hide": [
   "Toàn bộ HANA Ezy, Box, Hei, Edu",
   "Giá cước, giá bán",
   "Chuyến của tài xế khác"
  ],
  "dec": [
   [
    "Không có quyết định",
    "chi ngoài định mức → xin điều độ trước"
   ]
  ],
  "pains": [
   "Thao tác khi đang chờ ở cổng cảng, sóng yếu",
   "Chụp chứng từ giao nhận bị mờ, phải chụp lại",
   "Không rõ khoản chi nào được thanh toán lại"
  ],
  "scr": [
   [
    "HANA Mov",
    "Mint-Mov-Phone"
   ],
   [
    "HANA Mov · chuyến",
    "Mint-Mov-Phone2"
   ],
   [
    "HANA Mov · cá nhân",
    "Mint-Mov-Phone3"
   ]
  ],
  "hub": {
   "ezy": "no",
   "box": "no",
   "hei": "no",
   "mee": "no",
   "edu": "no",
   "mov": "main"
  },
  "impl": [
   "Nút 52–60px, chữ lớn, dùng được khi đeo găng",
   "Offline trước: mốc, ảnh POD gửi bù",
   "Không bao giờ hiện giá cước / giá bán; chỉ tạm ứng và lương chuyến của mình",
   "Khoá màn khi xe chạy, chỉ còn nút báo sự cố"
  ],
  "qs": [
   "Anh thường mở app lúc nào: ở cổng, khi chờ hay khi dừng xe?",
   "Khi mất sóng anh gửi ảnh giao hàng thế nào?",
   "Khoản chi nào anh hay phải ứng tiền túi?"
  ]
 },
 {
  "code": "TRD-TEC",
  "dept": "TRD",
  "name": "Cố vấn kỹ thuật",
  "rpt": "TRD-MGR",
  "lv": "L03–L05",
  "cert": "",
  "abbr": "TEC",
  "sum": "Giữ đầu kéo, rơ-moóc luôn sẵn sàng, an toàn, đúng hạn pháp lý; quản lý tài sản xe suốt vòng đời.",
  "duties": [
   "Lập, theo dõi lịch bảo dưỡng theo km / thời gian",
   "Theo dõi hạn đăng kiểm, bảo hiểm; nhắc trước 30 ngày",
   "Nhận sự cố kỹ thuật từ tài xế, chỉ định garage, theo tới khi đóng",
   "Duyệt báo cáo phương tiện tháng: ảnh, lốp, cabin, ODO",
   "Giám sát nhiên liệu, ODO qua định vị; phát hiện bất thường",
   "Đề xuất thanh lý / thay mới xe"
  ],
  "auth": [
   [
    "VEHICLE-MAINT",
    "Đặt lịch, xác nhận bảo dưỡng, đóng sự cố"
   ]
  ],
  "authNote": "Sửa chữa vượt hạn mức bậc trình Trưởng phòng",
  "kpi": [
   "Tỷ lệ xe sẵn sàng",
   "Bảo dưỡng đúng hạn",
   "Sự cố kỹ thuật trên đường",
   "Chi phí bảo dưỡng / km",
   "Đăng kiểm, bảo hiểm không quá hạn"
  ],
  "thinLv": "",
  "thin": "",
  "levels": [
   [
    "L03",
    3,
    2,
    "VEHICLE-MAINT"
   ],
   [
    "L04",
    3,
    1,
    "VEHICLE-MAINT"
   ],
   [
    "L05",
    3,
    0,
    "VEHICLE-MAINT"
   ]
  ],
  "nDuty": 7,
  "ctx": [
   "ht",
   "vp"
  ],
  "dev": [
   "ph",
   "pad"
  ],
  "net": "mid",
  "ctxK": "Bãi xe · garage",
  "loops": [
   [
    "Nhận báo sự cố từ tài xế",
    "N",
    "1–5"
   ],
   [
    "Ghi hoàn tất bảo dưỡng",
    "T",
    "3–8"
   ],
   [
    "Rà hạn đăng kiểm, bảo hiểm",
    "T",
    "1"
   ],
   [
    "Duyệt báo cáo phương tiện",
    "Th",
    "1 đợt"
   ],
   [
    "Rà nhiên liệu, ODO bất thường",
    "T",
    "1"
   ]
  ],
  "see": [
   "Hồ sơ xe, lịch bảo dưỡng",
   "Hạn đăng kiểm, bảo hiểm",
   "Sự cố mở",
   "Nhiên liệu, ODO từ định vị",
   "Báo giá garage"
  ],
  "hide": [
   "Giá cước, giá bán",
   "Số tài chính lô ngoài màn tài chính"
  ],
  "dec": [
   [
    "Chỉ định garage, hạng mục",
    "trong hạn mức bậc (L04) · vượt → TRD-MGR"
   ],
   [
    "Đóng sự cố kỹ thuật",
    "VEHICLE-MAINT"
   ]
  ],
  "pains": [
   "Ảnh báo cáo phương tiện tháng thiếu / sai góc",
   "Sự cố báo qua điện thoại, không vào hệ thống"
  ],
  "scr": [
   [
    "Đội xe & danh mục",
    "Mint-TMS-Fleet"
   ],
   [
    "Điều độ",
    "Mint-TMS"
   ],
   [
    "HANA Mov · cá nhân",
    "Mint-Mov-Phone3"
   ]
  ],
  "hub": {
   "ezy": "main",
   "box": "yes",
   "hei": "yes",
   "mee": "yes",
   "edu": "yes",
   "mov": "perm"
  },
  "impl": [
   "Duyệt báo cáo phương tiện dạng lưới ảnh trên iPad",
   "Sự cố từ Mov vào thẳng hàng chờ kỹ thuật"
  ],
  "qs": [
   "Tài xế báo hỏng xe cho anh bằng cách nào?",
   "Báo cáo phương tiện tháng anh duyệt mất bao lâu?",
   "Anh cần cảnh báo nhiên liệu / ODO ở mức nào?"
  ]
 },
 {
  "code": "ACC-CA",
  "dept": "ACC",
  "name": "Kế toán trưởng",
  "rpt": "BOD-DIR",
  "lv": "L07",
  "cert": "Chứng chỉ kế toán trưởng",
  "abbr": "KTT",
  "sum": "Chịu trách nhiệm tính trung thực của sổ sách, nghĩa vụ thuế và dòng tiền công ty.",
  "duties": [
   "Tổ chức hạch toán, báo cáo tài chính, quyết toán thuế",
   "Kiểm soát dòng tiền, kế hoạch thu chi, cảnh báo thiếu hụt",
   "Duyệt hạn mức công nợ; đồng duyệt giải phóng hàng / D/O khi còn dư nợ",
   "Soát xét lãi lỗ theo lô, dịch vụ; chất vấn chênh lệch",
   "Xác định đúng thuế suất VAT từng dịch vụ",
   "Làm việc với thuế, ngân hàng, kiểm toán"
  ],
  "auth": [
   [
    "CREDIT-OVERRIDE",
    "Cho vượt hạn mức / giữ release"
   ],
   [
    "PAYMENT-APPROVE",
    "Duyệt chi"
   ],
   [
    "WRITE-OFF",
    "Xoá nợ"
   ]
  ],
  "authNote": "Trong hạn mức của bậc · đồng duyệt bắt buộc TELEX-RELEASE, DO-RELEASE",
  "kpi": [
   "Số ngày thu tiền bình quân",
   "Tỷ lệ nợ quá hạn",
   "Thời hạn đóng sổ tháng",
   "Sai lệch quyết toán thuế"
  ],
  "thinLv": "",
  "thin": "",
  "levels": [],
  "nDuty": 7,
  "ctx": [
   "vp"
  ],
  "dev": [
   "pc"
  ],
  "net": "ok",
  "ctxK": "Văn phòng",
  "loops": [
   [
    "Duyệt chi",
    "N",
    "5–20"
   ],
   [
    "Đồng duyệt D/O / telex khi còn dư nợ",
    "T",
    "2–5"
   ],
   [
    "Duyệt vượt hạn mức công nợ",
    "T",
    "1–3"
   ],
   [
    "Khoá kỳ, đóng sổ",
    "Th",
    "1"
   ],
   [
    "Quyết toán thuế",
    "Th",
    "theo kỳ"
   ]
  ],
  "see": [
   "Toàn bộ màn tài chính",
   "Dòng tiền, kế hoạch thu chi",
   "Lãi lỗ theo lô, dịch vụ",
   "Chi hộ / thu hộ chưa cân",
   "Cờ EXC, NDC vượt định mức"
  ],
  "hide": [
   "Lương chi tiết (thuộc quyền HR, theo phân quyền)"
  ],
  "dec": [
   [
    "Duyệt chi",
    "PAYMENT-APPROVE · trên ngưỡng tạm (chờ chốt)"
   ],
   [
    "Vượt hạn mức / giữ release",
    "CREDIT-OVERRIDE"
   ],
   [
    "Xoá nợ",
    "WRITE-OFF"
   ],
   [
    "Khoá / mở kỳ",
    "PERIOD-LOCK · ghế trống → BOD-DIR"
   ]
  ],
  "pains": [
   "Ghế đang trống: mọi duyệt leo lên BOD-DIR, dễ nghẽn",
   "Đồng duyệt song song không thấy bên kia đã duyệt chưa"
  ],
  "scr": [
   [
    "Chi phí & Costing",
    "Mint-Cost"
   ],
   [
    "Thanh toán",
    "Mint-Payments"
   ],
   [
    "Công nợ",
    "Mint-AR"
   ],
   [
    "Phải trả",
    "Mint-SupplierPay"
   ],
   [
    "Định mức",
    "Mint-Norms"
   ],
   [
    "Việc & Duyệt",
    "Mint-Tasks"
   ]
  ],
  "hub": {
   "ezy": "main",
   "box": "yes",
   "hei": "yes",
   "mee": "yes",
   "edu": "yes",
   "mov": "no"
  },
  "impl": [
   "Hàng chờ duyệt theo ghế, hiện \"Ghế trống · leo lên BOD-DIR\"",
   "Đồng duyệt hiện 2 ô trạng thái song song",
   "Màn khoá kỳ chặn khi số dư chi hộ / thu hộ lệch"
  ],
  "qs": [
   "(Khi có người giữ ghế) Một ngày anh/chị duyệt bao nhiêu khoản chi?",
   "Đồng duyệt D/O cần thấy gì để quyết nhanh?",
   "Khoá kỳ đang bị chặn bởi việc gì nhiều nhất?"
  ]
 },
 {
  "code": "ACC-AR",
  "dept": "ACC",
  "name": "Kế toán bán hàng — công nợ",
  "rpt": "ACC-CA",
  "lv": "L02–L05",
  "cert": "",
  "abbr": "AR",
  "sum": "Thu hồi công nợ khách đúng hạn; mọi dịch vụ đã cung cấp đều thu đủ.",
  "duties": [
   "Phát hành debit / hoá đơn theo đề nghị của CS, kiểm đúng đủ phí",
   "Phát hành bổ sung khi Kế toán chi phí báo lô có chi chưa thu",
   "Theo dõi tuổi nợ, nhắc thu theo lịch",
   "Xác nhận đã thu đủ trước khi CS phát D/O lô nhập",
   "Đối chiếu, bù trừ công nợ với khách, hãng, đại lý",
   "Cảnh báo, chặn lô mới khi khách vượt hạn mức"
  ],
  "auth": [
   [
    "INVOICE-ISSUE",
    "Phát hành hoá đơn bán"
   ],
   [
    "CREDIT-ALERT",
    "Cảnh báo / chặn hạn mức (từ L03)"
   ]
  ],
  "authNote": "Vượt hạn mức thuộc KTT · không hạch toán hoá đơn mua vào (tách đầu chi)",
  "kpi": [
   "Số ngày thu tiền bình quân",
   "Nợ quá hạn > 30 ngày",
   "Hoá đơn phát hành đúng hạn",
   "Đối chiếu công nợ đúng kỳ"
  ],
  "thinLv": "",
  "thin": "",
  "levels": [
   [
    "L02",
    3,
    2,
    "INVOICE-ISSUE"
   ],
   [
    "L03",
    3,
    2,
    "INVOICE-ISSUE, CREDIT-ALERT"
   ],
   [
    "L04",
    3,
    1,
    "INVOICE-ISSUE, CREDIT-ALERT"
   ],
   [
    "L05",
    3,
    1,
    "INVOICE-ISSUE, CREDIT-ALERT"
   ]
  ],
  "nDuty": 9,
  "ctx": [
   "vp"
  ],
  "dev": [
   "pc"
  ],
  "net": "ok",
  "ctxK": "Văn phòng",
  "loops": [
   [
    "Phát hành debit / hoá đơn",
    "N",
    "10–30"
   ],
   [
    "Nhắc thu",
    "N",
    "5–20"
   ],
   [
    "Xác nhận thu đủ cho D/O",
    "N",
    "2–6"
   ],
   [
    "Đối chiếu công nợ",
    "Th",
    "1 đợt"
   ],
   [
    "Báo cáo tuổi nợ",
    "Th",
    "1"
   ]
  ],
  "see": [
   "Đề nghị phát hành từ CS",
   "Hoá đơn, debit, tuổi nợ",
   "Thanh toán khách",
   "Hạn mức công nợ",
   "Lô có chi chưa thu"
  ],
  "hide": [
   "Hạch toán hoá đơn mua vào (tách đầu chi)"
  ],
  "dec": [
   [
    "Phát hành hoá đơn",
    "INVOICE-ISSUE"
   ],
   [
    "Cảnh báo / chặn lô mới khi vượt hạn mức",
    "CREDIT-ALERT · cho vượt → ACC-CA"
   ],
   [
    "Xác nhận thu đủ trước D/O",
    "từ L03"
   ]
  ],
  "pains": [
   "CS hỏi \"thu đủ chưa\" qua chat, không có trạng thái trên lô",
   "Khách chưa xác nhận debit, nhắc tay nhiều lần"
  ],
  "scr": [
   [
    "Hoá đơn",
    "Mint-Invoice"
   ],
   [
    "Công nợ",
    "Mint-AR"
   ],
   [
    "Thanh toán",
    "Mint-Payments"
   ],
   [
    "Việc & Duyệt",
    "Mint-Tasks"
   ]
  ],
  "hub": {
   "ezy": "main",
   "box": "yes",
   "hei": "yes",
   "mee": "yes",
   "edu": "yes",
   "mov": "no"
  },
  "impl": [
   "Nút \"Xác nhận thu đủ\" trên lô nhập, CS thấy ngay (chưa có)",
   "Nhắc khách xác nhận debit theo nhịp, cc Sale"
  ],
  "qs": [
   "CS hỏi chị \"lô này thu đủ chưa\" bao nhiêu lần một ngày?",
   "Chị nhắc nợ bằng kênh nào hiệu quả nhất?",
   "Đối chiếu công nợ cuối kỳ vướng ở đâu?"
  ]
 },
 {
  "code": "ACC-CP",
  "dept": "ACC",
  "name": "Kế toán chi phí",
  "rpt": "ACC-CA",
  "lv": "L02–L05",
  "cert": "",
  "abbr": "CP",
  "sum": "Ghi nhận đúng, đủ chi phí mua của từng lô để lãi lỗ theo lô và dịch vụ phản ánh đúng thực tế.",
  "duties": [
   "Nhận, kiểm hoá đơn mua vào; nhập bảng kê, đối chiếu HĐ điện tử",
   "Đối chiếu từng khoản với chi phí trên lô, làm rõ lệch trước khi hạch toán",
   "Phát hiện lô có chi chưa có thu, chuyển CS + Kế toán công nợ",
   "Phân bổ chi phí đội xe",
   "Quyết toán tạm ứng hiện trường, tài xế; chặn ứng mới khi đợt cũ chưa xong",
   "Theo dõi khoản không thu được: bỏ chỗ, lưu bãi, lưu cont, bồi thường"
  ],
  "auth": [
   [
    "INVOICE-IN-POST",
    "Hạch toán hoá đơn mua vào (từ L03)"
   ],
   [
    "ADVANCE-SETTLE",
    "Quyết toán tạm ứng (từ L04)"
   ]
  ],
  "authNote": "Vượt hạn mức trình KTT · không phát hành hoá đơn bán, không điều chỉnh công nợ khách ở bất kỳ bậc nào",
  "kpi": [
   "HĐ mua vào hạch toán đúng hạn",
   "Lô đóng sổ thiếu chi phí",
   "Lô có chi không có thu",
   "Thời gian ra lãi lỗ tháng",
   "Tạm ứng quá hạn"
  ],
  "thinLv": "",
  "thin": "",
  "levels": [
   [
    "L02",
    3,
    2,
    ""
   ],
   [
    "L03",
    3,
    2,
    "INVOICE-IN-POST"
   ],
   [
    "L04",
    4,
    1,
    "INVOICE-IN-POST, ADVANCE-SETTLE"
   ],
   [
    "L05",
    3,
    1,
    "INVOICE-IN-POST, ADVANCE-SETTLE"
   ]
  ],
  "nDuty": 9,
  "ctx": [
   "vp"
  ],
  "dev": [
   "pc"
  ],
  "net": "ok",
  "ctxK": "Văn phòng",
  "loops": [
   [
    "Nhập bảng kê HĐ mua vào",
    "N",
    "20–60 dòng"
   ],
   [
    "Ghép HĐ vào dòng chi trên lô",
    "N",
    "20+"
   ],
   [
    "Quyết toán tạm ứng",
    "T",
    "5–15"
   ],
   [
    "Phân bổ chi phí đội xe",
    "Th",
    "1"
   ],
   [
    "Báo cáo khoản không thu được",
    "Th",
    "1"
   ]
  ],
  "see": [
   "Costing theo lô, dịch vụ",
   "HĐ mua vào, HĐ điện tử",
   "Tạm ứng theo người",
   "Lô có chi chưa thu",
   "Mã bản chất OBH · BIL · ABS · EXC"
  ],
  "hide": [
   "Phát hành hoá đơn bán, điều chỉnh công nợ khách"
  ],
  "dec": [
   [
    "Hạch toán HĐ mua vào",
    "INVOICE-IN-POST · vượt hạn mức → ACC-CA"
   ],
   [
    "Quyết toán tạm ứng; chặn ứng mới",
    "ADVANCE-SETTLE · từ L04"
   ]
  ],
  "pains": [
   "HĐ về chậm, PND treo lâu",
   "OPS gọi tên khoản chi khác với chứng từ"
  ],
  "scr": [
   [
    "Chi phí & Costing",
    "Mint-Cost"
   ],
   [
    "Quyết toán",
    "Mint-Settle"
   ],
   [
    "Phải trả",
    "Mint-SupplierPay"
   ],
   [
    "Chi phí theo mảng",
    "Mint-OpsCost"
   ],
   [
    "Định mức",
    "Mint-Norms"
   ]
  ],
  "hub": {
   "ezy": "main",
   "box": "yes",
   "hei": "yes",
   "mee": "yes",
   "edu": "yes",
   "mov": "no"
  },
  "impl": [
   "Ghép HĐ hàng loạt theo gợi ý, xác nhận từng nhóm",
   "Danh sách quyết toán theo người, chặn ứng mới hiện rõ"
  ],
  "qs": [
   "Một ngày chị ghép bao nhiêu hoá đơn vào lô?",
   "Khoản nào hay bị OPS ghi sai bản chất?",
   "Quyết toán tạm ứng chậm nhất là vì đâu?"
  ]
 },
 {
  "code": "HRD-MGR",
  "dept": "HRD",
  "name": "Trưởng phòng Hành chính — Nhân sự",
  "rpt": "BOD-DIR",
  "lv": "L07",
  "cert": "",
  "abbr": "HR",
  "sum": "Đủ người đúng vị trí, hồ sơ lao động đúng luật, hành chính thông suốt.",
  "duties": [
   "Quản lý cơ cấu: mở / đóng ghế, quan hệ báo cáo",
   "Tuyển dụng theo kế hoạch đã duyệt",
   "Hợp đồng lao động, BHXH, hồ sơ nhân sự; tính lương theo thang bậc",
   "Theo dõi hiệu lực chứng chỉ bắt buộc (khai HQ, GPLX, KTT)",
   "Phát hành JD theo phiên bản, lưu ký nhận",
   "Đánh giá định kỳ, đề xuất thăng bậc trình BOD"
  ],
  "auth": [
   [
    "POSITION-CREATE",
    "Mở ghế mới"
   ],
   [
    "ASSIGNMENT-EDIT",
    "Giao / đổi ghế"
   ],
   [
    "PAYROLL-PREPARE",
    "Lập bảng lương"
   ]
  ],
  "authNote": "Mở ghế mới, đổi bậc phải có Giám đốc duyệt trước khi ghi nhận",
  "kpi": [
   "Thời gian lấp ghế trống",
   "Tỷ lệ nghỉ việc",
   "Hồ sơ lao động đầy đủ",
   "Độ chính xác bảng lương",
   "Chứng chỉ còn hiệu lực"
  ],
  "thinLv": "",
  "thin": "",
  "levels": [],
  "nDuty": 9,
  "ctx": [
   "vp"
  ],
  "dev": [
   "pc"
  ],
  "net": "ok",
  "ctxK": "Văn phòng",
  "loops": [
   [
    "Duyệt đơn phép / tăng ca",
    "N",
    "3–10"
   ],
   [
    "Cập nhật hồ sơ, HĐLĐ",
    "T",
    "3–8"
   ],
   [
    "Rà chứng chỉ sắp hết hạn",
    "Th",
    "1"
   ],
   [
    "Lập bảng lương",
    "Th",
    "1"
   ],
   [
    "Giao ghế, mở ghế",
    "Th",
    "khi có"
   ]
  ],
  "see": [
   "Cơ cấu & ghế",
   "Hồ sơ, HĐLĐ, chứng chỉ",
   "Bảng lương (quyền lương)",
   "JD theo phiên bản + ký nhận"
  ],
  "hide": [
   "Số tài chính lô, giá bán"
  ],
  "dec": [
   [
    "Mở ghế, đổi bậc",
    "cần BOD-DIR duyệt trước"
   ],
   [
    "Giao ghế Primary / Concurrent / Acting",
    "ASSIGNMENT-EDIT"
   ],
   [
    "Quyết định nhân sự",
    "HRD-MGR lập → BOD-DIR duyệt"
   ]
  ],
  "pains": [
   "Chứng chỉ hết hạn phát hiện muộn",
   "Ký nhận JD theo phiên bản làm trên giấy"
  ],
  "scr": [
   [
    "Nhân sự",
    "Mint-HR"
   ],
   [
    "Hồ sơ",
    "Mint-StaffProfile"
   ],
   [
    "Quyết định",
    "Mint-HRDecision"
   ],
   [
    "Bảng lương",
    "Mint-Payroll"
   ],
   [
    "HĐ lao động",
    "Mint-LaborContract"
   ],
   [
    "Sơ đồ tổ chức",
    "Mint-HR-OrgTree"
   ]
  ],
  "hub": {
   "ezy": "main",
   "box": "yes",
   "hei": "yes",
   "mee": "yes",
   "edu": "yes",
   "mov": "no"
  },
  "impl": [
   "Lịch hết hạn chứng chỉ gắn với ghế cần chứng chỉ",
   "Phát hành JD → ký nhận qua Mee"
  ],
  "qs": [
   "Chị biết chứng chỉ ai sắp hết hạn bằng cách nào?",
   "Ký nhận JD đang làm thế nào?",
   "Giao ghế Acting khi có người nghỉ mất bao lâu?"
  ]
 },
 {
  "code": "HRD-IT",
  "dept": "HRD",
  "name": "Nhân viên Công nghệ thông tin",
  "rpt": "HRD-MGR",
  "lv": "L02–L05",
  "cert": "",
  "abbr": "IT",
  "sum": "Hệ thống và hạ tầng CNTT chạy ổn định, dữ liệu được sao lưu, truy cập đúng phân quyền.",
  "duties": [
   "Hỗ trợ người dùng: tài khoản, thiết bị, sự cố phần mềm",
   "Quản trị tài khoản, phân quyền theo phòng, bậc, dịch vụ",
   "Vận hành cảnh báo giờ chốt cho phòng CS",
   "Theo dõi tác vụ tự động, xử lý lỗi đồng bộ",
   "Kiểm sao lưu và khả năng khôi phục",
   "Nhận yêu cầu cải tiến, viết lại thành yêu cầu kỹ thuật; cập nhật hướng dẫn"
  ],
  "auth": [
   [
    "USER-PROVISION",
    "Tạo / khoá tài khoản theo yêu cầu đã duyệt"
   ]
  ],
  "authNote": "Không tự quyết phạm vi phân quyền · đổi cấu trúc dữ liệu cần duyệt (L05)",
  "kpi": [
   "Thời gian xử lý yêu cầu hỗ trợ",
   "Thời gian gián đoạn",
   "Tỷ lệ sao lưu thành công"
  ],
  "thinLv": "note",
  "thin": "JD còn ghi \"hệ thống eLog\", SharePoint — chưa theo HANA Ezy / Hub",
  "levels": [
   [
    "L02",
    2,
    2,
    "USER-PROVISION"
   ],
   [
    "L03",
    3,
    1,
    "USER-PROVISION"
   ],
   [
    "L04",
    3,
    1,
    "USER-PROVISION"
   ],
   [
    "L05",
    3,
    1,
    "USER-PROVISION"
   ]
  ],
  "nDuty": 7,
  "ctx": [
   "vp"
  ],
  "dev": [
   "pc"
  ],
  "net": "ok",
  "ctxK": "Văn phòng",
  "loops": [
   [
    "Hỗ trợ người dùng",
    "N",
    "5–15"
   ],
   [
    "Tạo / khoá tài khoản",
    "T",
    "1–3"
   ],
   [
    "Rà tác vụ tự động, lỗi đồng bộ",
    "N",
    "1–2"
   ],
   [
    "Phân loại góp ý, giao chủ phân hệ",
    "N",
    "3–10"
   ],
   [
    "Kiểm sao lưu, khôi phục",
    "Th",
    "1"
   ]
  ],
  "see": [
   "Tài khoản, phân quyền theo ghế",
   "Nhật ký thao tác",
   "Hàng chờ góp ý",
   "Trạng thái tích hợp (M365, Zalo OA)"
  ],
  "hide": [
   "Số tài chính lô, lương (trừ khi được cấp)"
  ],
  "dec": [
   [
    "Tạo / khoá tài khoản",
    "USER-PROVISION · theo yêu cầu HR đã duyệt"
   ],
   [
    "Giao góp ý cho chủ phân hệ",
    "Admin IT"
   ]
  ],
  "pains": [
   "Yêu cầu hỗ trợ đến qua chat, không ghi lại",
   "Phân quyền theo ghế khó kiểm khi kiêm nhiệm"
  ],
  "scr": [
   [
    "Quản trị",
    "Mint-Admin"
   ],
   [
    "M365",
    "Mint-M365"
   ],
   [
    "Action Log",
    "Mint-ActionLog"
   ],
   [
    "Cài đặt",
    "Mint-Settings"
   ],
   [
    "Zalo OA",
    "Mint-ZaloOA"
   ]
  ],
  "hub": {
   "ezy": "main",
   "box": "yes",
   "hei": "yes",
   "mee": "yes",
   "edu": "yes",
   "mov": "perm"
  },
  "impl": [
   "Xem quyền \"như người dùng X\" để kiểm phân quyền",
   "Góp ý / sự cố vào một hàng chờ có trạng thái"
  ],
  "qs": [
   "Một ngày anh nhận bao nhiêu yêu cầu, qua kênh nào?",
   "Kiểm một người có đúng quyền theo ghế mất bao lâu?",
   "Lỗi đồng bộ nào hay gặp nhất?"
  ]
 },
 {
  "code": "BOD-DIR",
  "dept": "BOD",
  "name": "Giám đốc",
  "rpt": "",
  "lv": "L09",
  "cert": "",
  "abbr": "GĐ",
  "sum": "Điều hành toàn công ty, chịu trách nhiệm cuối cùng về kết quả kinh doanh và tuân thủ.",
  "duties": [
   "Duyệt kế hoạch kinh doanh, ngân sách, định biên",
   "Quyết các trường hợp vượt thẩm quyền trưởng phòng",
   "Duyệt kế hoạch giữ chỗ vượt ngưỡng",
   "Ấn định thang bậc lương, duyệt thay đổi cơ cấu",
   "Ký kết hợp đồng, làm việc với đối tác chiến lược"
  ],
  "auth": [
   [
    "—",
    "Không giới hạn · điểm dừng cuối của mọi escalation"
   ]
  ],
  "authNote": "Ghế trống ở dưới (vd ACC-CA) thì duyệt leo lên ghế này",
  "kpi": [
   "LN trước thuế",
   "Tăng trưởng kinh doanh",
   "Dòng tiền"
  ],
  "thinLv": "thin",
  "thin": "JD chưa rõ việc trên hệ thống: nhiệm vụ cấp chiến lược, yêu cầu \"không áp dụng\"",
  "levels": [],
  "nDuty": 5,
  "ctx": [
   "vp",
   "ht"
  ],
  "dev": [
   "ph",
   "pc"
  ],
  "net": "mid",
  "ctxK": "Văn phòng · đi gặp đối tác",
  "loops": [
   [
    "Duyệt việc vượt thẩm quyền",
    "N",
    "3–10"
   ],
   [
    "Xem báo cáo BOD",
    "T",
    "1–2"
   ],
   [
    "Chốt kỳ KPI",
    "Th",
    "1"
   ],
   [
    "Duyệt quyết định nhân sự",
    "Th",
    "2–5"
   ]
  ],
  "see": [
   "Báo cáo BOD, KPI",
   "Mọi màn tài chính",
   "Hàng chờ duyệt leo lên ghế mình"
  ],
  "hide": [
   "Không có (theo quyền)"
  ],
  "dec": [
   [
    "Mọi việc vượt thẩm quyền trưởng phòng",
    "không giới hạn"
   ],
   [
    "Kế hoạch giữ chỗ vượt ngưỡng",
    "JD chưa ghi số"
   ],
   [
    "Quyết định nhân sự, mở ghế, đổi bậc",
    "—"
   ]
  ],
  "pains": [
   "Duyệt dồn vì ghế ACC-CA trống",
   "Duyệt trên điện thoại thiếu tóm tắt rủi ro"
  ],
  "scr": [
   [
    "Báo cáo BOD",
    "Mint-BOD"
   ],
   [
    "Báo cáo BOD · điện thoại",
    "Mint-BOD-Phone"
   ],
   [
    "KPI",
    "Mint-KPI"
   ],
   [
    "Việc & Duyệt",
    "Mint-Tasks"
   ]
  ],
  "hub": {
   "ezy": "main",
   "box": "yes",
   "hei": "yes",
   "mee": "yes",
   "edu": "yes",
   "mov": "perm"
  },
  "impl": [
   "Duyệt trên điện thoại: thẻ tóm tắt + 1 chạm, lý do bắt buộc khi từ chối",
   "Hàng chờ phân biệt \"leo lên do ghế trống\""
  ],
  "qs": [
   "Anh duyệt phần lớn trên điện thoại hay máy tính?",
   "Một yêu cầu duyệt cần tóm tắt gì để anh quyết trong 1 phút?",
   "Anh muốn thấy gì đầu tuần trên báo cáo BOD?"
  ]
 },
 {
  "code": "BOD-DDIR",
  "dept": "BOD",
  "name": "Phó Giám đốc",
  "rpt": "BOD-DIR",
  "lv": "L08",
  "cert": "",
  "abbr": "PGĐ",
  "sum": "Hỗ trợ Giám đốc điều hành mảng được phân công; thay mặt khi được uỷ quyền.",
  "duties": [
   "Điều hành mảng được phân công (JD chưa rõ mảng nào)",
   "Duyệt thay Giám đốc trong phạm vi, thời hạn uỷ quyền",
   "Chủ trì dự án cải tiến liên phòng",
   "Giám sát tuân thủ quy chế nội bộ"
  ],
  "auth": [
   [
    "Acting",
    "Theo văn bản uỷ quyền có thời hạn"
   ]
  ],
  "authNote": "Uỷ quyền ghi bằng giao ghế Acting, không ghi cứng vào chức danh",
  "kpi": [
   "JD chưa rõ — \"theo mảng được phân công\""
  ],
  "thinLv": "thin",
  "thin": "JD chưa rõ: mảng phụ trách, KPI (\"theo mảng được phân công\"), không có dòng bậc",
  "levels": [],
  "nDuty": 4,
  "ctx": [
   "vp"
  ],
  "dev": [
   "pc",
   "ph"
  ],
  "net": "ok",
  "ctxK": "Văn phòng",
  "loops": [
   [
    "Duyệt thay Giám đốc khi được uỷ quyền",
    "N",
    "khi Acting"
   ],
   [
    "Theo dõi dự án cải tiến",
    "T",
    "1"
   ],
   [
    "Xem KPI mảng phụ trách",
    "T",
    "1"
   ]
  ],
  "see": [
   "Hàng chờ duyệt theo uỷ quyền",
   "Báo cáo mảng phụ trách",
   "KPI"
  ],
  "hide": [
   "JD chưa rõ — tuỳ mảng được phân công"
  ],
  "dec": [
   [
    "Duyệt thay BOD-DIR",
    "theo phạm vi, thời hạn uỷ quyền"
   ],
   [
    "Duyệt myHANA thay BOD-DIR",
    "nếu không phải người đã xác minh"
   ]
  ],
  "pains": [
   "Không rõ đang được uỷ quyền gì, đến khi nào",
   "Mảng phụ trách không có màn riêng"
  ],
  "scr": [
   [
    "Báo cáo BOD",
    "Mint-BOD"
   ],
   [
    "KPI",
    "Mint-KPI"
   ],
   [
    "Việc & Duyệt",
    "Mint-Tasks"
   ],
   [
    "Duyệt myHANA",
    "Mint-PortalApprove"
   ]
  ],
  "hub": {
   "ezy": "main",
   "box": "yes",
   "hei": "yes",
   "mee": "yes",
   "edu": "yes",
   "mov": "no"
  },
  "impl": [
   "Chip \"Acting đến dd/MMM\" trên mọi bước duyệt thay",
   "Phạm vi uỷ quyền hiện ngay đầu hàng chờ"
  ],
  "qs": [
   "Anh/chị phụ trách mảng nào, KPI đo bằng gì?",
   "Khi được uỷ quyền, anh/chị biết phạm vi bằng cách nào?",
   "Việc duyệt thay hay vướng ở đâu?"
  ]
 }
];
